import FieldRenderer from "../global/forms/FieldRenderer";
import dataConstants from "../../constants/dataConstants";
import useStateAndCity from "../../services/utils/custom hooks/useStateAndCity";
import { optionType } from "../organism/CustomSelect";
import InviteUserProps from "../../services/models/formModels/inviteuserFields.model";

function GenerateLabelFields({
  touched,
  errors,
  handleChange,
  handleBlur,
  setFieldValue,
  values,
  getFieldMeta,
}: InviteUserProps): JSX.Element {
  const { data } = useStateAndCity();
  const stateCities = data?.find((state: any) => {
    return state.state_code === values.stateValue;
  })?.cities;
  const cities = stateCities?.map(
    (city: any): optionType => ({ label: city.name, value: city.name })
  );
  const states: optionType[] = data?.map((state: any) => ({
    label: state.name,
    value: state.state_code,
  }));
  return (
    <FieldRenderer
      fields={dataConstants.generateLabelfields.map((field, index) => {
        if (field?.isForm?.name === "stateValue") {
          return {
            options: states,
            isForm: {
              ...field.isForm,
              labelInfo: {
                ...field.isForm.labelInfo,
              },
              setFieldValue,
              errors,
              values,
              getFieldMeta,
              touched,
              parentContainerClass: "!w-[48%] mx-1 my-3 mt-4 h-[20px]",
            },
          };
        }
        if (field.name === "city" || field.name === "stateValue") {
          return {
            ...field,
            labelInfo: {
              ...field.labelInfo,
              inputId: field.name,
            },
            setFieldValue: setFieldValue,
            key: `${index}${field.labelInfo?.inputId}`,
            errors: errors,
            values,
            getFieldMeta,
            touched: touched,
            onChange: handleChange,
            value: values?.[!!field?.name ? field.name : ""],
            onBlur: handleBlur,
            name: field.name,
            roundedInput: true,
            checkBoxClassName: "inline-block mr-3",
            parentContainerClass: ["city"].includes?.(
              field?.name ? field.name : ""
            )
              ? "!w-[47%] mx-2.5"
              : "",
            suggestions: field.name === "stateValue" ? states : cities,
          };
        }
        return {
          ...field,
          labelInfo: {
            ...field.labelInfo,
            inputId: field.name,
          },
          setFieldValue: setFieldValue,
          key: `${index}${field.labelInfo?.inputId}`,
          errors: errors,
          values,
          getFieldMeta,
          touched: touched,
          onChange: handleChange,
          value: values?.[!!field?.name ? field.name : ""],
          onBlur: handleBlur,
          name: field.name,
          roundedInput: true,
          checkBoxClassName: "inline-block mr-3",
          parentContainerClass: ["address"].includes?.(
            field?.name ? field.name : ""
          )
            ? "!w-[98.5%]"
            : [
                "firstName",
                "lastName",
                "email",
                "phone",
                "state",
                "stateValue",
                "zipCode",
                "shipmentDate",
                "city",
              ].includes?.(field?.name ? field.name : "")
            ? "w-full md:!w-[47%] mx-2.5"
            : "",
        };
      })}
    />
  );
}

export default GenerateLabelFields;
